import { FunctionComponent } from 'react';
import { Link } from 'react-router';
import { useNavigationPaths } from '../../propertyAssociation/useNavigationPaths';

const NewBookingButton: FunctionComponent = () => {
    const paths = useNavigationPaths();
    
    return (
        <Link to={paths.newBooking} className='btn btn-secondary'>Boka</Link>
    )
}

export default NewBookingButton